import styled, { css } from "styled-components/macro";

import { MixinStyledInput } from "components/Input/styles";

export const maxWidthRootPages = "50rem";

export const HomeDiv = styled.div`
  display: block;
  position: relative;
  width: 100%;
  text-align: center;
  margin: 0 auto 0;
  background-color: ${(props) => props.theme.colors.bgBody};
  & > section {
    margin: 0 auto 2rem;
    & > div > button {
      font-size: 24px;
    }
    @media ${(props) => props.theme.media.phone} {
      margin: 0 auto 2rem;
    }
  }
`;
export const FooterHospi = styled.footer`
  display: block;
  background-color: ${(props) => props.theme.colors.bgDark};
  position: relative;
  text-align: center;
  & > ul {
    margin-top: 24px;
    display: inline-grid;
    gap: 16px;
    grid-template-columns: max-content max-content;

    & > li {
      list-style: none;
      & > a {
        color: ${(props) => props.theme.colors.place};
        font-size: ${(props) => props.theme.font.size};
        &:hover {
          color: ${(props) => props.theme.colors.primary};
        }
      }
    }
    @media ${(props) => props.theme.media.phone} {
      grid-template-columns: max-content;
    }
  }

  & > div {
    display: flex;
    justify-content: space-between;
    width: 120px;
    margin: 0 auto;
    padding: 16px 0 32px;
    & > a {
      width: 32px;
      height: 32px;
    }
  }

  & > span {
    position: absolute;
    bottom: 16px;
    right: 16px;
    color: ${(props) => props.theme.colors.place};
    @media ${(props) => props.theme.media.phone} {
      position: relative;
      right: initial;
    }
  }

  @media (max-width: 350px) {
    & > ul {
      margin-top: 8px;
      grid-template-columns: 1fr;
      gap: 8px;
    }

    & > div {
      padding: 0 0 32px 0;
    }

    & > span {
      bottom: 6px;
    }
  }
`;

export const BannerSection = styled.section<{ imageLink: string }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: url(${(props) => props.imageLink}) center/cover no-repeat;
  height: 70vh;
  padding: 6em 2em;
  margin: 6rem auto 0;
  & > h1 {
    margin: 0 auto;
  }
  @media ${(props) => props.theme.media.phone} {
    padding: 5em 2em;
    height: 50vh;
    &.home {
      padding: 1em;
    }
  }
`;

export const BannerSectionHome = styled.section<{ imageLink: string }>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background: url(${(props) => props.imageLink}) center/cover no-repeat;
  height: 70vh;
  margin: 6rem auto 0;
  & > h1 {
    margin: 0 auto;
  }
  @media ${(props) => props.theme.media.phone} {
    padding: 5em 2em;
    height: 50vh;
    &.home {
      padding: 1em;
    }
  }
`;

export const TitleUnderLine = styled.h2`
  align-content: center;
  border-bottom: 2px solid ${(props) => props.theme.colors.primary};
  display: inline-block;
  margin-bottom: 25px;
  color: ${(props) => props.theme.colors.text};
  font-size: ${(props) => props.theme.font.sizeBanner};
  font-weight: ${(props) => props.theme.font.weightBold};
  @media ${(props) => props.theme.media.phone} {
    font-size: ${(props) => props.theme.font.sizeTitle};
  }
`;

export const LimitWidthSection = styled.section`
  max-width: ${maxWidthRootPages};
  width: 100%;
  padding: 1rem;
`;

export const DarkSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 48px 0;
  padding: 40px;
  flex-direction: column;
  background-color: #323232;
  & > h2 {
    color: ${(props) => props.theme.colors.place};
    margin: 0 0 54px;
  }
  & > button {
    min-width: 7em;
    align-self: center;
  }
  @media ${(props) => props.theme.media.phone} {
    padding: 16px;
  }
`;

export const PictureLink = styled.a<{ logo: string; bgSize?: string }>`
  display: block;
  background: url(${(props) => props.logo}) center/contain no-repeat;
  height: 10rem;
  ${(props) =>
    props.bgSize &&
    css`
      background-size: ${props.bgSize};
    `}
`;

export const RoadMapGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  @media ${(props) => props.theme.media.tablet} {
    grid-template-columns: repeat(3, minmax(180px, 1fr));
  }
  @media ${(props) => props.theme.media.phone} {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }

  gap: 32px;
  margin: 0 32px;
`;

export const StepRoadMapDiv = styled.div`
  & > p {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    font-size: 20px;
    color: ${(props) => props.theme.colors.place};
    background-color: ${(props) => props.theme.colors.primary};
    line-height: 200%;
    margin: 0 auto 8px;
  }
  & > h2:last-child {
    font-weight: 200;
  }
`;

export const ItemLink = styled.a`
  font-size: 18px;
  color: ${(props) => props.theme.colors.primary};
  text-align: left;
`;

export const SendEmail = styled.form`
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  max-width: ${maxWidthRootPages};
  width: 100%;
  gap: 24px;
  @media ${(props) => props.theme.media.phone} {
    grid-template-columns: 1fr;
  }
  & > h2 {
    color: ${(props) => props.theme.colors.place};
  }
  & > input {
    ${MixinStyledInput}
  }
`;
